module.exports = __webpack_public_path__ + "img/zainDrone-img1.515581c4.png";